export interface PlaybackSettings {
  interval: number;
  shuffle: boolean;
  repeat: boolean;
  paused: boolean;
}

export const MIN_PLAYBACK_INTERVAL_MINUTES = 5;
export const MIN_PLAYBACK_INTERVAL_SECONDS = MIN_PLAYBACK_INTERVAL_MINUTES * 60;

export const DEFAULT_PLAYBACK_SETTINGS: PlaybackSettings = {
  interval: MIN_PLAYBACK_INTERVAL_SECONDS,
  shuffle: false,
  repeat: true,
  paused: false,
};

export interface BigDisplay {
  id: number;
  android_id: string;
  store_id: string;
  current_image: string[];
  location_code?: string;
  battery_level: number | null;
  battery_updated_at?: string | null;
  wifi_rssi: number | null;
  orientation?: 'portrait' | 'landscape';
  playback_settings?: PlaybackSettings;
  display_type?: string;
}

export interface BigDisplayResponse {
  limit: number;
  offset: number;
  total: number;
  displays: BigDisplay[];
}
